import React from "react";
import { useDatadogGcp } from "@/hooks/useDatadogGcp";

const DatadogGcpDashboard = () => {
  const { embedUrl } = useDatadogGcp();

  return (
    <div className="datadog-container">
      <iframe
        title="Datadog Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default DatadogGcpDashboard;